import React from 'react';
import { RootStateOrAny, useSelector } from 'react-redux'
import IndexTermList from './IndexTermList';

const ExternalCauses = () => {
    const externalCauses = useSelector((state: RootStateOrAny) => state.externalCauses)
    const externalCausesCount = useSelector((state: RootStateOrAny) => state.externalCausesCount)
    const searchTerm = useSelector((state: RootStateOrAny) => state.searchTerm)

    if (!externalCausesCount) return null;
    return (
        <div id="external-causes" className="page-anchor">
            <div id="{{getValidID(indexTitle)}}" className="section-divider">External Causes of Injuries Index</div>
            <IndexTermList terms={externalCauses} searchTerm={searchTerm} />
        </div>
    )
}

export default ExternalCauses;


